module.exports = __webpack_public_path__ + "static/media/adult.d61bd1f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/adult.jpg
// module id = 439
// module chunks = 0